import React from 'react';
import classNames from 'classnames';
import { Chip, ChipProps } from '@mui/material';
import styles from './table-tag.module.scss';

export interface TableTagProps extends Omit<ChipProps, 'label'> {
    label: string;
    title?: string;
}

export const TableTag: React.FC<TableTagProps> = ({
    label,
    title,
    className,
    classes,
    ...rest
}) => {
    return (
        <Chip
            {...rest}
            label={label}
            title={title ?? label}
            className={classNames(styles.root, className)}
            classes={{
                label: styles.label,
                ...classes,
            }}
        />
    );
};

export default TableTag;
